module.exports = __webpack_public_path__ + "static/media/shelter_transitional_marker.72c10515.svg";